module.exports = __webpack_public_path__ + "static/media/ic_link_facebook.8ce859e8.svg";